import React, { Component } from "react";

import SignInForm from "../../molecules/SignInForm";
import SignInGoogle from "../../molecules/SignInGoogle";
import SignInFacebook from "../../molecules/SignInFacebook";
import SignInTwitter from "../../molecules/SignInTwitter";
import SignUpLink from "../../scenes/SignUp/atoms/SignUpLink";
import PasswordForgetLink from "../../../../molecules/PasswordForget/atoms/PasswordForgetLink";
import SignInGithub from "../../molecules/SignInGithub";
import HeaderLogo from "../../../../../assets/StartBibles.jpeg";

class SignIn extends Component {
  render() {
    return (
      <div className="login">
        <div className="login__content">
          <div className="login__content__inner">
            <div className="login__content__header">
              <img
                className="login__content__header__logo"
                src={HeaderLogo}
                alt="logo"
              />
              {/* <div className="login__content__header__title">
                
              </div> */}
            </div>
            <div className="login__content__login-form">
              <div className="login__content__form">
                <SignInForm />
              </div>
              <div className="login__content__password-forget">
                <PasswordForgetLink />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="login__image" /> */}
      </div>
    );
  }
}

export default SignIn;
